import classNames from 'classnames';
import _ from 'lodash';
import { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import tinycolor from 'tinycolor2';
import { layoutDefaults } from '../utils/layout-defaults';

const htmlContainerMargin = 34;
const htmlContainerMarginHorizontal = 10;

function useSwal({
  storage,
  includesTitleBottomMargin = false,
  // footerClassName,
}) {
  const fontFamily = useMemo(() => {
    if (!_.isEmpty(storage?.menuLayout?.text?.default_font)) {
      return storage?.menuLayout?.text?.default_font;
    }

    return layoutDefaults.fontFamily;
  }, [storage?.menuLayout?.text?.default_font]);

  const backdropColor = useMemo(() => {
    if (!_.isEmpty(storage?.menuLayout?.background?.container_color)) {
      return tinycolor(storage?.menuLayout?.background?.container_color)
        .setAlpha(layoutDefaults.opacity)
        .toRgbString();
    }

    return tinycolor(layoutDefaults.primaryColor)
      .setAlpha(layoutDefaults.opacity)
      .toRgbString();
  }, [storage?.menuLayout?.background?.container_color]);

  const classes = useStyles(fontFamily);

  const swalCustomClass = useMemo(
    () => ({
      container: classes.container,
      popup: classes.popup,
      content: classes.content,
      htmlContainer: classes.htmlContainer,
      icon: classes.icon,
      title: classNames(
        classes.title,
        includesTitleBottomMargin ? classes.titleBottomMargin : null
      ),
      closeButton: classes.closeButton,
      confirmButton: 'btn btn-primary btn-md btn-block',
      cancelButton: 'btn btn-secondary btn-md btn-block',
      denyButton: 'btn btn-secondary btn-md btn-block',
      loader: classes.loader,
      // actions: classNames("d-grid", classes.actions),
      actions: classes.actions,
      input: classNames('form-control', classes.input),
      validationMessage: classes.validationMessage,
      footer: classes.footer,
      // actions: classes.actions,
    }),
    [includesTitleBottomMargin, fontFamily]
  );

  const willOpen = () => {
    storage?.setShowingModal(true);
    // history.push(`/${menuSlug}/popup`);
  };

  const willClose = () => {
    storage?.setShowingModal(false);
    // history.replace(`/${menuSlug}`);
  };

  const swal = useMemo(() => {
    if (storage == null) return null;

    const swalWithReactContent = withReactContent(Swal);
    return swalWithReactContent.mixin({
      // target: $(".swal-target")[0],
      // target: "#swal-target",
      customClass: swalCustomClass,
      buttonsStyling: false,
      allowOutsideClick: false,
      allowEnterKey: false,
      allowEscapeKey: true,
      willOpen,
      // didOpen: willOpen,
      willClose,
      // loaderHtml: <>xx</>,
      // grow: "fullscreen",
      // closeButtonHtml: (
      //   <div className={classes.chevron}>
      //     <BsChevronRight />
      //   </div>
      // ),
      backdrop: `
          rgba(0,0,0,0.0)
          `,
      // backdrop: `
      // ${tinycolor(layoutDefaults.primaryColor)
      //   .setAlpha(0.86)
      //   .toRgbString()}
      // `,
    });
  }, [swalCustomClass, backdropColor, storage]);

  return {
    swal,
  };
}

const useStyles = createUseStyles({
  container: {
    touchAction: 'pan-x pan-y',
  },
  popup: {
    fontFamily: (fontFamily) => fontFamily,
    fontSize: layoutDefaults.fontSize,
    borderRadius: layoutDefaults.radius,
    paddingBottom: `${
      htmlContainerMargin - layoutDefaults.smallerVerticalMargin
    }px !important`,
    touchAction: 'pan-x pan-y',
    // border: `1px solid red`,
  },
  content: {
    // Estava errada a escrita
    // margin: layoutDefaults.biggestVerticalMargin,
    // border: `1px solid red`,
  },
  htmlContainer: {
    padding: `${htmlContainerMargin}px !important`,
    paddingLeft: `${htmlContainerMarginHorizontal}px !important`,
    paddingRight: `${htmlContainerMarginHorizontal}px !important`,
    paddingBottom: `${layoutDefaults.verticalMargin}px !important`,
    justifyContent: 'unset',
    margin: 'unset',
    // border: `1px solid red`,
  },
  icon: {
    marginTop: `${layoutDefaults.biggerVerticalMargin}px !important`,
    marginBottom: `-${layoutDefaults.verticalMargin}px !important`,
  },
  title: {
    fontFamily: (fontFamily) => fontFamily,
    fontSize: layoutDefaults.biggestFontSize,
    marginBottom: `-${layoutDefaults.bigVerticalMargin}px !important`,
    zIndex: 1,
  },
  titleBottomMargin: {
    marginBottom: `-${layoutDefaults.smallestVerticalMargin}px !important`,
  },
  closeButton: {
    fontWeight: 250,
    // fontFamily: 'none !important',
  },
  loader: {
    borderColor: '#f0bf5f transparent #f0bf5f transparent',
    marginTop: 12,
    marginBottom: 12,
  },
  actions: {
    flexDirection: 'column',
    padding: `0 ${htmlContainerMargin}px !important`,
    justifyContent: 'unset',
    margin: 'unset',
    zIndex: 0,
  },
  input: {
    width: 'auto',
    fontSize: layoutDefaults.fontSize,
    margin: `2rem ${htmlContainerMargin}px !important`,
    touchAction: 'pan-x pan-y',
  },
  validationMessage: {
    fontFamily: (fontFamily) => fontFamily,
    fontSize: layoutDefaults.fontSize,

    marginTop: 0,
    marginBottom: layoutDefaults.verticalMargin,
  },
  footer: {
    marginBottom: -layoutDefaults.smallVerticalMargin,
  },
});

export { useSwal };
